import { Exclude, Type } from 'class-transformer'
import { CardString, Suit, Value } from 'pokersolver'

import { CryptoProvider, DefaultCryptoProvider } from '../util/CryptoProvider'

export const Suits: Suit[] = ['c', 'd', 'h', 's']
export const Values: Value[] = ['2', '3', '4', '5', '6', '7', '8', '9', 'T', 'J', 'Q', 'K', 'A']

/**
 * A standard 52-card deck implementaton
 *
 * Deck will use an environment defined crypto provider for secure random generation.
 * This behavior is provided by the `DefaultCryptoProvider`. If another crypto provider
 * is required, `deckInstance.setCryptoProvider` may be used.
 */
export class Deck {
  /**
   *
   */
  // @Exclude()
  private cryptoProvider!: CryptoProvider

  // @Type(() => String)
  cards: CardString[]

  constructor() {
    this.cards = this.buildDeck()
  }

  /**
   * Builds a new card deck
   * @returns new card deck
   */
  buildDeck() {
    const newDeck: CardString[] = []
    Suits.forEach((suit) => {
      Values.forEach((value) => {
        newDeck.push((value + suit) as unknown as CardString)
      })
    })
    return newDeck
  }

  /**
   * Removes one card from the top of the deck
   */
  burnOne() {
    this.cards.splice(0, 1)
  }

  /**
   * Rebuilds this Deck from scratch
   */
  rebuild() {
    this.cards = this.buildDeck()
  }

  /**
   * Shuffles this Deck using Fisher-Yates random swap
   */
  shuffleFisherYates() {
    for (let i = 0; i < this.cards.length; i++) {
      const j = this.getRandomInt(i + 1)
      ;[this.cards[i], this.cards[j]] = [this.cards[j], this.cards[i]]
    }
  }

  /**
   * Shuffles this Deck using Sattolo random swap, ensures there's a derangement
   */
  shuffleSattolo() {
    // TODO: review this line
    // biome-ignore lint/suspicious/noAssignInExpressions: <explanation>
    for (let i = this.cards.length; (i -= 1); ) {
      const j = this.getRandomInt(i)
      ;[this.cards[i], this.cards[j]] = [this.cards[j], this.cards[i]]
    }
  }

  validCard(card: string) {
    if (card.length !== 2) {
      return false
    }

    if (Values.filter((value) => card.slice(0, 1).toLowerCase() === value.toLowerCase()).length === 0) {
      return false
    }

    if (Suits.filter((suit) => card.slice(1, 2).toLowerCase() === suit).length === 0) {
      return false
    }

    return true
  }
  /**
   * Sets the crypto provider for this deck. May be used to override the
   * DefaultCryptoProvider().
   *
   * Must be called before Deck is shuffled.
   *
   * @param provider a CryptoProvider instance
   */
  setCryptoProvider(provider: CryptoProvider) {
    this.cryptoProvider = provider
  }

  private getRandomInt(size: number): number {
    return Math.floor(size * Math.random())
    // const randomBuffer = new Uint32Array(1)
    // crypto.getRandomValues(randomBuffer)
    // return randomBuffer[0] % size
    // if (!this.cryptoProvider) {
    //   this.cryptoProvider = new DefaultCryptoProvider()
    // }

    // return this.cryptoProvider.randomInt(size)
  }
}
